import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import '../App.css';

const PrivacyPolicyES = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    // If opened in new tab, close the window; otherwise navigate back
    if (window.history.length <= 2) {
      window.close();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="landing-page">
      {/* Header */}
      <header className="header">
        <div className="header-container">
          <div className="logo">
            <img src="/epg_logo.png" alt="EPG Logo" className="logo-icon" />
          </div>
          <div className="header-buttons">
            <Button variant="outline" className="header-btn" onClick={handleBack}>
              Volver
            </Button>
          </div>
        </div>
      </header>

      {/* Privacy Policy Content */}
      <section className="contact-section" style={{ paddingTop: '120px', paddingBottom: '80px' }}>
        <div className="contact-container" style={{ maxWidth: '800px' }}>
          <h1 className="contact-title" style={{ fontSize: '2.5rem', marginBottom: '2rem' }}>
            Política de Privacidad
          </h1>
          <div style={{ 
            color: 'rgba(255, 255, 255, 0.9)', 
            lineHeight: '1.8',
            fontSize: '1.1rem',
            textAlign: 'left'
          }}>
            <p style={{ marginBottom: '1.5rem' }}>
              Electrum Prosperity Group ("EPG") respeta su privacidad y está comprometido a proteger su información personal. Cuando visita nuestro sitio web, se registra o interactúa con nuestros servicios, podemos recopilar información básica como su nombre, dirección de correo electrónico o detalles de contacto únicamente para comunicarnos con usted, proporcionar recursos y mejorar nuestros servicios.
            </p>
            <p style={{ marginBottom: '1.5rem' }}>
              Al utilizar nuestro sitio web y servicios, usted acepta esta política de privacidad. Si tiene alguna pregunta o inquietud sobre cómo se maneja su información, contáctenos directamente.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyES;
